import React, {
  useState, Suspense, lazy
} from 'react';
import styled from 'styled-components';
import HamburgerMenuIcon from './HamburgerMenuIcon';
import renderCTAOptions from '../renderCTAOptions';
import renderMobileCTAOptions from '../renderMobileCTAOptions';
import renderFeaturedMobileSpot from '../renderFeaturedMobileSpot';
import { HamburgerMenu as HamburgerMenuProps } from './types/types';

const OffCanvas = lazy(() => import('react-aria-offcanvas'));

const StyledHamburgerMenu = styled.div`
display: none;
@media (max-width: 992px) {
  display: block;
  order: 1;
}
`;

const HamburgerMenu = ({
  featuredLinksMobileMenu, mobileNavigationLinks, featuredMobileSpot, ctaButtons,
}: HamburgerMenuProps) => {
  const isSSR = typeof window === 'undefined';
  const [nav, showNav] = useState(false);

  return (
    <StyledHamburgerMenu>
      <HamburgerMenuIcon
        clickCallback={() => showNav(!nav)}
        menuOpen={nav}
      />
      {!isSSR && (
        <Suspense fallback={<div />}>
          <OffCanvas
            role="menu"
            isOpen={nav}
            onClose={() => showNav(false)}
            height="100%"
            width="70vw"
            style={
              {
                overlay: { zIndex: '1000' },
                content: {
                  background: '#ffffff',
                  overflow: 'scroll',
                  padding: '3rem 1rem 3rem 3rem',
                  boxShadow: 'rgb(0 0 0 / 5%) 0px 2px 4px 0px',
                },
              }
            }
          >
            {ctaButtons?.length !== 0
              && (
                <>
                  <ul className="row">
                    {ctaButtons?.map((item, index) => (
                      <li key={index}>
                        <span
                          tabIndex={0}
                          role="button"
                          onClick={() => showNav(!nav)}
                          onKeyDown={() => showNav(!nav)}
                          style={{paddingRight: '0.5rem'}}
                        >
                          {renderCTAOptions(item?.sys?.contentType?.sys?.id || item?.contentfulContentType, item)}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <hr />
                </>
              )}
            {mobileNavigationLinks?.length !== 0
              && (
                <>
                  <ul>
                    {mobileNavigationLinks?.map((item, index) => (
                      <li key={index}>
                        <span
                          tabIndex={0}
                          role="button"
                          onClick={() => showNav(!nav)}
                          onKeyDown={() => showNav(!nav)}
                        >
                          {renderMobileCTAOptions(item?.sys?.contentType?.sys?.id || item?.contentfulContentType, item)}
                        </span>
                      </li>
                    ))}
                  </ul>
                  <hr />
                </>
              )}
            {featuredLinksMobileMenu?.length !== 0
              && (
                <>
                  <ul>
                    {featuredLinksMobileMenu?.map((item, index) => (
                      <li key={index}>
                        {renderMobileCTAOptions(item?.sys?.contentType?.sys?.id || item?.contentfulContentType, item)}
                      </li>
                    ))}
                  </ul>
                </>
              )}
            {featuredMobileSpot
              && (
                <div className="block__featured">
                  {/* eslint-disable-next-line max-len */}
                  {renderFeaturedMobileSpot(featuredMobileSpot, featuredMobileSpot?.sys?.contentType?.sys?.id || featuredMobileSpot?.contentfulContentType)}
                </div>
              )}
          </OffCanvas>
        </Suspense>
      )}
    </StyledHamburgerMenu>
  );
};

export default HamburgerMenu;
